import React from 'react';
import { Button } from 'antd';
import type { AnyFormConfig, ItemWithId } from '../../types/types';

interface EditModalFooterProps {
  config: AnyFormConfig | null;
  item: ItemWithId | null;
  itemType: string | null;
  isAdding: boolean;
  onClose: () => void;
  onSave: () => void;
  onSetImage: () => void;
  onSetSymbolImage: () => void;
  /** Navigates to the map and highlights the given item; provided by the Container */
  onViewOnMap: (item: ItemWithId | null, itemType: string | null) => void;
  /** Heals the given party member to full HP; provided by the Container */
  onHealToFull: (item: ItemWithId | null) => void;
}

/**
 * Presenter component for EditModal footer buttons (ADR-034).
 *
 * Pure UI -- all side-effectful actions (view on map, heal, save, close)
 * are received as callback props from the Container via TypedEditModal.
 */
const EditModalFooter: React.FC<EditModalFooterProps> = ({ config, item, itemType, isAdding, onClose, onSave, onSetImage, onSetSymbolImage, onViewOnMap, onHealToFull }) => {
  if (!config) return null;

  return (
    <>
      {config.buttons?.viewOnMap && !isAdding && <Button key="viewOnMap" onClick={() => onViewOnMap(item, itemType)}>View on Map</Button>}
      {config.buttons?.healToFull && !isAdding && <Button key="healToFull" onClick={() => onHealToFull(item)}>Heal to Full</Button>}
      {config.buttons?.setImage && <Button key="setImage" onClick={onSetImage}>Set Image</Button>}
      {config.buttons?.setSymbolImage && <Button key="setSymbolImage" onClick={onSetSymbolImage}>Set Symbol Image</Button>}
      <Button key="cancel" onClick={onClose}>Cancel</Button>
      <Button key="save" type="primary" onClick={onSave}>Save</Button>
    </>
  );
};

export default EditModalFooter;
